import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppSelector } from 'app/config/store';
import { getPartsByCompany } from 'app/entities/part/part.reducer';
import { extractOnlyIds } from 'app/shared/util/functions-util';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import PartModal from './PartModal';
import './part.scss';

type PartSelectionModalProps = {
  selectedParts: any[];
  setSelectedParts: any;
  modalOpen: boolean;
  setModalOpen: any;
};

export const PartSelectionModal = React.memo(({ selectedParts, setSelectedParts, modalOpen, setModalOpen }: PartSelectionModalProps) => {
  const dispatch = useDispatch();
  const [currentSelectedParts, setCurrentSelectedParts] = useState([]);
  const [selectedPart, setSelectedPart] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedPartsFirst, setSelectedPartsFirst] = useState([]);

  const parts = useAppSelector(state => state.part.entities);
  const filteredParts = parts.filter(
    part => part.name.toLowerCase().includes(searchTerm.toLowerCase()) || part.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    dispatch(getPartsByCompany({ page: 0, size: 10000, sort: 'id' }));
  }, []);

  useEffect(() => {
    setSelectedPartsFirst(extractOnlyIds(selectedParts));
    setCurrentSelectedParts(extractOnlyIds(selectedParts));
  }, [selectedParts]);

  useEffect(() => {
    currentSelectedParts?.length === parts?.length ? setSelectAllChecked(true) : setSelectAllChecked(false);
  }, [currentSelectedParts, parts]);

  const filteredPartsSorted = filteredParts.sort((a, b) => {
    const aSelected = selectedPartsFirst.includes(a.id);
    const bSelected = selectedPartsFirst.includes(b.id);
    if (aSelected && !bSelected) {
      return -1;
    } else if (!aSelected && bSelected) {
      return 1;
    } else {
      return 0;
    }
  });

  const handleSelectPart = partId => {
    const index = currentSelectedParts.indexOf(partId);
    if (index === -1) {
      setCurrentSelectedParts([...currentSelectedParts, partId]);
    } else {
      const updatedSelectedParts = [...currentSelectedParts];
      updatedSelectedParts.splice(index, 1);
      setCurrentSelectedParts(updatedSelectedParts);
    }
  };

  const handleSave = () => {
    setSelectedParts(currentSelectedParts);
    setModalOpen(false);
  };

  const toggleModal = () => {
    setCurrentSelectedParts(extractOnlyIds(selectedParts));
    setSearchTerm('');
    setModalOpen((prev: boolean) => !prev);
  };

  const handleSelectAll = () => {
    if (selectAllChecked) {
      setCurrentSelectedParts([]);
    } else {
      setCurrentSelectedParts(filteredParts.map(part => part.id));
    }
  };

  return (
    <Fragment>
      {selectedPart && <PartModal part={selectedPart} toggle={() => setSelectedPart(null)} isOpen={!!selectedPart} />}
      <Modal isOpen={modalOpen} toggle={toggleModal} >
        <ModalHeader toggle={toggleModal}>Selecione as peças</ModalHeader>
        <ModalBody style={{ maxHeight: '50vh', overflow: 'auto' }} >
          <div className="d-flex align-items-center justify-content-end">
            <FormGroup>
              <Input
                bsSize="sm"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                type="text"
                name="search"
                id="search"
                placeholder="Nome ou Código"
              />
              {!searchTerm ? (
                <FontAwesomeIcon icon={faSearch} style={{ position: 'absolute', top: '25px', right: '25px' }} color={'#2cb4b4'} />
              ) : (
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  style={{ position: 'absolute', top: '18px', right: '25px' }}
                  onClick={() => setSearchTerm('')}
                >
                  <span aria-hidden="true">×</span>
                </button>
              )}
            </FormGroup>
          </div>
          {!!filteredPartsSorted?.length && (
            <FormGroup check style={{ margin: '10px', marginTop: 0 }}>
              <Label check>
                <Input type="checkbox" checked={selectAllChecked} onChange={handleSelectAll} />
                <span className="not-hover">Selecionar Todas</span>
              </Label>
            </FormGroup>
          )}
          {filteredPartsSorted.map(part => (
            <div key={part.id} className="container-modal-update">
              <FormGroup check title={part.code ? `${part.name} - ${part.code}` : part.name}>
                <Label check className="not-hover">
                  <Input type="checkbox" checked={currentSelectedParts.indexOf(part.id) !== -1} onChange={() => handleSelectPart(part.id)} />
                  <span className="not-hover">{part.name + (part.code && ' -')}</span>
                  {part.code && <small className="not-hover">{part.code}</small>}
                </Label>
                <FontAwesomeIcon icon="eye" onClick={() => setSelectedPart(part)} />{' '}
              </FormGroup>
            </div>
          ))}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSave}>
            Salvar
          </Button>{' '}
          <Button color="secondary" onClick={toggleModal} outline>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
});
